import { Select } from '@mantine/core';

import { Departments } from '@/types';

type Props = {
  value?: Departments;
  onSelect: (value: Departments) => any;
};

export const DepartmentsSelect = ({ value, onSelect }: Props) => {
  const data = Object.values(Departments).map((value) => ({ value, label: value.toUpperCase() }));

  return (
    <Select
      value={value}
      comboboxProps={{
        withinPortal: true,
        transitionProps: { transition: 'pop', duration: 200, timingFunction: 'ease' },
      }}
      data={data}
      onChange={(value) => {
        if (value && Object.values(Departments).includes(value as any)) {
          onSelect(value as Departments);
        }
      }}
      w={100}
    />
  );
};
